import React from 'react';
import Parent from './parent';
import {withTranslation} from 'react-i18next';
import { constants } from './constants/constants';
import {BllinkLogger} from './utils/bllink_loggers';
import CacheData from './utils/cacheData';
import {GAEvent} from "./google_analytics/google_analytics";
import DropDown from './simple/dropDown';
import './installmentsSelect.css';
import {Currency} from "./currency";

export class InstallmentsSelect extends Parent {

    constructor(props) {
        super(props);
        BllinkLogger.info(`constructor props for installments select is `, props)
        this.t = props.t;
        this.ltr = this.t('direction') === 'ltr';
        this.state = this.newState(props);
        this.onSelectChange.bind(this);
        this.onFocus.bind(this);
    }

    async componentDidMount() {
        const isAdmin = await this.isAdmin();
        this.setState({
            isAdmin
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedNumberOfInstallments !== this.state.selectedNumberOfInstallments) {
            this.setState(this.newState(this.state));
        }
        if (prevProps !== this.props) {
            BllinkLogger.info(`props for installments select is `, this.props);
            this.setState(this.newState(this.props));
            if (this.props.name) {
                this.cacheSelectedIfNotCached(this.props.selectedNumberOfInstallments || this.state.defaultNumberOfInstallments, this.props.name);
            }
        }
    }

    newState(props) {
        BllinkLogger.info(`props select installments `, props);
        const paymentMethodResult = props.managerOptions;
        const result = this.getInstallmentsResult(props);

        return  {
            ...result,
            ...paymentMethodResult
        }
    }


    getInstallmentsResult(props) {
        const maxInstallments = props.maxNumberOfInstallments || 1;
        const installmentsOptions = this.calcInstallmentOptions(maxInstallments);
        const selectedNumberOfInstallments = this.selectedNumberOfPayments(props, maxInstallments);
        const totalForFirstMonth = this.calcFirstPaymentAmount(props, selectedNumberOfInstallments);
        const total = this.Money.roundNumber(props.total || 0);
        // https://app.asana.com/0/1196545425570329/1200307774346154 considering rewards
        const totalReward = this.Money.roundNumber(props.totalReward || 0);

        // removing this because of a bug in debt payments - this component was called before maxNumberOfInstallments
        // was known and 1 was selected as number of payments
        // https://app.asana.com/0/1196545425570329/1197753510454947
        // this.cacheSelected(selectedNumberOfInstallments, props.name);

        if (selectedNumberOfInstallments > 1) {
            // on going 12 installments is not sticky and it should be
            // https://app.asana.com/0/1196545425570329/1198989844236485
            this.cacheSelectedIfNotCached(selectedNumberOfInstallments, props.name);
        }
        // [bug] debt installments select
        // https://app.asana.com/0/1196545425570329/1199383389776783
        if (!props.ignoreMaxInstallments) {
            if (selectedNumberOfInstallments >= maxInstallments) {
                this.cacheSelected(maxInstallments, props.name);
            }
        }

        return {
            total: total,
            totalReward: totalReward,
            name: props.name, // used to unique cache selection
            onChangeFunc: props.onChange,
            selectOptions: installmentsOptions,
            totalForFirstMonth: totalForFirstMonth,
            maxNumberOfInstallments: maxInstallments,
            defaultNumberOfInstallments: selectedNumberOfInstallments,
            currency: (props.currency || constants.defaultCurrency).toLowerCase(),
        };
    }

    calcFirstPaymentAmount(props, selectedNumberOfInstallments) {
        if (props.firstPayment) {
            // take first payment from server. taking the total and dividing
            // could be irrelevant at this point. for example in offline cheques, they can be
            // un evenly distributed
            return props.firstPayment
        } else {
            let isPartPay = (props.partPay && props.partPay.value);
            let total = isPartPay ? props.partPay.value : props.total;
            total = parseFloat(total);
            let totalReward = props.totalReward || 0;
            total += parseFloat(totalReward || 0);
            // todo this assumes the total reward always takes from the first payment. todo generalize this

            if (this.props.months) {
                const selectedMonths = this.props.months.filter(month => month.selected);
                if (selectedMonths.length === selectedNumberOfInstallments && selectedMonths.length) {
                    // fix. Without it sometimes fails on some rerender
                    const toPay = selectedMonths[0]?.part_pay?.value || selectedMonths[0]?.amountLeft?.value || selectedMonths[0]?.amount_left?.value || 0;
                    return this.Money.roundNumber(toPay);
                }
            }
            let firstPaymentAmount = this.Money.calcPlanByAveragePayment(total , selectedNumberOfInstallments)[0];
            return this.Money.roundNumber(firstPaymentAmount - totalReward);
        }
    }


    selectedNumberOfPayments(props, maxInstallments) {
        // could be cached or just the default
        const data = CacheData.fetchCache('installmentsChoices',
            {key: props.name}
        );

        let initialChoice = props.defaultNumberOfInstallments || 1;
        if (data) {
            BllinkLogger.info(`loaded from cache for ${props.name} `, data.selected)
            initialChoice = data.selected;
        }
        // this in the case of already selected, just to show (AKA status page)
        if (props.selectedNumberOfInstallments) {
            initialChoice = props.selectedNumberOfInstallments;
            //https://app.asana.com/0/1196545425570329/1199229477272829 [Bug] user is selected 10 even though shown 1 in debt select box
            // return initialChoice
        }

        if (props.ignoreMaxInstallments) {
            // only for the confirmation(status) page (debt/on going and one time)
            BllinkLogger.info(`ignoring max. at this point the payments should have passed already`);
            return initialChoice;
        }

        const finalResult = Math.min(initialChoice, maxInstallments);
        BllinkLogger.info(`final number of installments is `, finalResult);

        return finalResult;
    }

    calcInstallmentOptions(maxInstallments) {
        return this.JsExtras.getRange(maxInstallments);
    }

    onFocus(currentSelectedValue) {
        BllinkLogger.info(`onFocus record direction `);
        // saving in order to record direction on google analytics
        this.currentSelectedValue = currentSelectedValue;
    }

    onSelectChange(newNumberOfInstallments) {
        BllinkLogger.info(`select installment ${this.state.name} onSelectChange ${newNumberOfInstallments}`);

        this.reportSelectChanged(newNumberOfInstallments);
        const totalForFirstMonth = this.Money.calcPlanByAveragePayment(this.state.total, newNumberOfInstallments)[0];

        this.cacheSelected(newNumberOfInstallments);

        // calling parent on change function in case defined
        if (this.state.onChangeFunc) {
            BllinkLogger.info(`calling onChangeFunc `)
            this.state.onChangeFunc();
        }

        this.setState({
            defaultNumberOfInstallments: newNumberOfInstallments,
            selectedNumberOfInstallments: newNumberOfInstallments,
            totalForFirstMonth: totalForFirstMonth,
        })
    }


    reportSelectChanged(newNumberOfInstallments) {
        const shouldReportSpecific = (this.currentSelectedValue && !isNaN(this.currentSelectedValue));
        if (shouldReportSpecific) {
            const direction = newNumberOfInstallments > this.currentSelectedValue ? 'increase': 'decrease';
            BllinkLogger.info(`reporting ${direction}`);
            GAEvent('selectInstallment', 'selectInstallmentChanged', 1, `selectInstallmentChanged_${direction}`);
        } else {
            BllinkLogger.info(`reporting general select change`);
            GAEvent('selectInstallment', 'selectInstallmentChanged', 1, 'general');
        }
    }

    cacheSelectedIfNotCached(selectedInstallments, name) {
        BllinkLogger.info(`cacheSelectedIfNotCached selectedInstallments ${selectedInstallments}`);
        // maybe don't cache if it's the default
        const data = CacheData.fetchCache('installmentsChoices',
            {key: name}
        );

        if (!data || data.selected !== selectedInstallments) {
           BllinkLogger.info(`caching installments since they are not cached `);
           this.cacheSelected(selectedInstallments, name);
        }
    }

    cacheSelected(selectedInstallments, name) {
        name = name || this.state.name;
        if (!name) {
            throw new Error('failed to uniquely save number of payments');
        }

        // maybe don't cache if it's the default
        // don't cache if it's 0
        if (selectedInstallments && selectedInstallments > 0) {
            CacheData.cache('installmentsChoices',
                {selected: selectedInstallments},
                {key: name}
            );
        }
    }


    selectInstallmentsHtml() {
        let managerSelect = '';
        let installmentsSelect = this.renderInstallmentSelect();

        if (this.state.shouldRenderManagerOptions) {
            managerSelect = this.renderOfflinePaymentOptions();
        }

        return (
            <>
                {managerSelect}
                {installmentsSelect}
            </>
        );
    }

    renderInstallmentSelect() {

        if (this.props.managerOptions && this.props.managerOptions.shouldNotRenderInstallmentsSelect){
            return '';
        }

        const shouldShouldUseNewDropDown = (
            this.state.shouldRenderManagerOptions &&
            this.props.managerOptions &&
            !this.props.managerOptions.shouldNotRenderInstallmentsSelect
        );
        if (shouldShouldUseNewDropDown) {
            return (
                <DropDown
                    onSelectChange={value => this.onSelectChange(value)}
                    onFocus={value => this.onFocus(value)}
                    value={this.state.defaultNumberOfInstallments}
                    options={this.state.selectOptions}
                    insideSelectBox={true}
                    underManagerSelect={true}
                />
            );
        }

        const dropDownClassName = this.props.classNameDiv ? [this.props.classNameDiv] : [
            'icon-dropdown-new',
            ...(this.props.data?.isOneTime ? ['icon-dropdown-one-time'] : []),
        ];

        // todo replace select with DropDown component
        // tried 3 times already..
        return (
            <div className={dropDownClassName.join(' ')}>
                <select
                    name="apartment-number"
                    id={this.props.selectID || "payment-dept-page-selection"}
                    onChange={e => this.onSelectChange(e.target.value)}
                    onFocus={e => this.onFocus(e.target.value)}
                    value={this.state.defaultNumberOfInstallments}
                >
                    {this.state.selectOptions.map((value, index) => (<option key={index} value={value} >{value}</option>))}
                </select>
            </div>
        );
    }

    renderOfflinePaymentOptions() {
        let insideSelectBox = true

        return (
            <DropDown
                onSelectChange={this.props.onPaymentMethodChanged}
                value={this.state.selectedPaymentMethod}
                options={this.state.paymentOptions}
                insideSelectBox={insideSelectBox}
            />
        );
    }

    renderPartPayAmountIfNeeded(_, props) {
        return this.renderPartPayAmount({}, props);
    }

    renderTotal() {
        // considering reward if relevant
        const s = this.BllinkUtils.Strings;

        if (this.state.totalReward) {
            return (
                <span>
                    <del className={'text-space'}>{s.numberWithCommas(this.state.totalReward + this.props.total)}</del>
                    {s.numberWithCommas(this.props.total)}
                </span>
            )
        }

        return s.numberWithCommas(this.props.total);
    }

    render() {
        const {t} = this.props;
        const s = this.BllinkUtils.Strings;
        BllinkLogger.info(`installment select props`, this.props);

        let selectHtml, textPClass = 'sums-side';
        if (this.props.hideSelectInstallments) {
            textPClass = 'installments-text-selected';
            selectHtml = <div className={textPClass}>{this.state.defaultNumberOfInstallments}</div>;
        } else {
            selectHtml = this.selectInstallmentsHtml();
        }

        BllinkLogger.info(`installment select render props `, this.props);
        let firstWeekAmount = <div className={`${textPClass} amount-in-box`}> {s.numberWithCommas(this.state.totalForFirstMonth)} {t('currency.' + this.state.currency)}</div>;
        if (this.props.managerOptions && this.props.managerOptions.shouldNotRenderInstallmentsSelect){
            firstWeekAmount = '';
        }

        let totalText = this.renderTotal();

        return(
            <section className={'label_container_select'}>
                {this.renderPartPayAmountIfNeeded(this.state, this.props)}
                <div
                    className={`${textPClass} amount-in-box`}
                    full-amount={this.props.total}
                    time-index={this.props.name}
                    currency={this.state.currency}
                >
                    {totalText} <Currency>{this.state.currency}</Currency>
                </div>
                {selectHtml}
                {firstWeekAmount}
            </section>
        )
    }
}


export default withTranslation()(InstallmentsSelect);
